export default import.meta.ROLLDOWN_FILE_URL_yW_eMvu1QqHghXJHMLbBbg